<template>
	<v-card flat>
		<v-card-text>
			<h3 class="mb-3 d-sm-none">Контрагент</h3>
			<v-divider class="d-sm-none" />
			<card-row title="Контактное лицо">{{ order.contact_name }}</card-row>
			<card-row title="Телефон">{{ order.contact_phone }}</card-row>
			<card-row title="Email">{{ order.contact_email }}</card-row>
			<v-divider />
			<card-row title="Контрагент">
				<router-link :to="`/clients/${order.place.client.id}`">
					{{ order.place.client.name }}
				</router-link>
			</card-row>
			<card-row title="Город">{{ order.place.city.name }}</card-row>
			<card-row title="Адрес">{{ order.place.address }}</card-row>
			<card-row title="Объект">{{ order.place.name }}</card-row>
			<v-divider />
			<card-row title="Оборудование">{{ order.machine.type }}</card-row>
			<card-row title="Название">{{ order.machine.name }}</card-row>
			<card-row title="Номер">{{ order.machine.serial_number }}</card-row>
			<card-row title="Пробег">{{ order.machine.engine_hours }}</card-row>
			<v-divider />
			<p class="mt-3 mb-1">Описание неисправности:</p>
			<v-textarea
				v-model="client_description"
				outlined
				hide-details
			/>
			<template v-if="showSaveClientDescriptionButton">
				<v-btn
					class="mt-3"
					color="primary"
					outlined
					@click="$emit('set:client-description', client_description)"
				>
					Сохранить
				</v-btn>
				<v-btn
					class="mt-3 ml-2"
					outlined
					@click="setClientDescriptionFromOrder"
				>
					Отмена
				</v-btn>
			</template>
		</v-card-text>
	</v-card>
</template>

<script>
import CardRow from '@/components/base/card-row';
export default {
	name: 'RepairOrderShowClientData',
	components: { CardRow },
	props: {
		order: {
			type: Object,
			required: true,
		},
	},
	data: () => ({
		client_description: '',
	}),
	computed: {
		showSaveClientDescriptionButton() {
			return this.client_description !== this.order.client_description;
		},
	},
	mounted() {
		this.setClientDescriptionFromOrder();
	},
	methods: {
		setClientDescriptionFromOrder() {
			this.client_description = this.order.client_description;
		},
	},
};
</script>

<style scoped>

</style>
